export default "__VITE_ASSET__Db$fCyVx__"